import * as React from 'react';
import countries, { Option } from '../../utils/countries';

type CompanyInfoformProps = {
  companyName: string;
  setCompanyName: Function;
  companyLocation: string;
  setCompanyLocation: Function;
};

export default function CompanyInfoForm(props: CompanyInfoformProps) {
  return (
    <React.Fragment>
      <div className="measure-wide">
        <label htmlFor="company_name" className="f6 b db mb2 ttu black-50 fw6">
          Company Name
        </label>
        <input
          id="company_name"
          className="input-reset ba b--black-20 pa2 mb2 db w-100"
          type="text"
          required
          onChange={(e) => props.setCompanyName(e.target.value)}
          defaultValue={props.companyName}
        />
      </div>
      <div className="measure-wide">
        <label htmlFor="country" className="f6 b db mb2 ttu black-50 fw6">
          Company Location
        </label>
        <select
          id="country"
          className="input-reset ba b--black-20 pa2 mb2 db w-100"
          required
          name="country"
          onChange={(e) => props.setCompanyLocation(e.target.value)}
        >
          <option value="">Please Select</option>
          {countries().map((country: Option) => (
            <option value={country.value}>{country.label}</option>
          ))}
        </select>
      </div>
    </React.Fragment>
  );
}
